
import { Dropdown } from "floating-vue";
import { removeHTMLTagFromString } from "~/utils";
import UiLazyImg from "~/components/UI/UiLazyImg.vue";
import UiButton from "~/components/UI/UiButton";

export default {
  components: {
    UiButton,
    UiLazyImg,
    Dropdown,
  },
  props: {
    data: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      imageContainerHeight: 121,
      content: {},
      distance: {},
      activePopperId: null,
    };
  },
  async fetch() {
    await this.getDiamondKnowledgeData();
  },
  methods: {
    async getDiamondKnowledgeData() {
      try {
        const { data } = await this.$api.pages.getBlok("diamond-knowledge");
        this.content = data.data?.currentTranslation?.content || {};
      } catch (err) {
        console.log("err - ", err?.response?.data?.errors);
      }
    },
    removeHTMLTagFromString,
    handleDropdownShow(id) {
      this.activePopperId = id;
      setTimeout(async () => {
        await this.$nextTick();
        const popperElement = document.getElementById("popper-" + id);
        if (popperElement) {
          const height = popperElement.offsetHeight;
          this.$set(this.distance, id, (-height - this.imageContainerHeight) / 2);
        }
      }, 0);
    },
    handleDropdownHide(id) {
      if (this.activePopperId === id) {
        this.activePopperId = null;
      }
    },
  },
};
